import { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";

import { useGetArtistMeta, useGetSuggestions } from "../../../../api/queries";
import LoadingSmall from "../../../../components/LoadingSmall";
import SocialSpotify from "../../../../components/SocialSpotify";
import Spacer from "../../../../components/Spacer";
// import AppState from "../../../../store/appstate";
import useAppStore from "../../../../store/appStateZustand";
import SuggestionsTable from "./SuggestionsTable";
// import RebrandButtonLink from "../../../../components/rebrandButtonLink";
// import Modal from "../../../../components/Modal";

function SongSuggestions({ highlightColour }) {
  // const { t } = useTranslation();
  // const [spotifyModalIsOpen, setSpotifyModalIsOpen] = useState(false);
  const [showSpotifyForm, setShowSpotifyForm] = useState(true);
  // const selectedAccount = AppState.useState(s => s.selectedAccount);
  const selectedAccount = useAppStore(s => s.selectedAccount);
  const artistMeta = useGetArtistMeta({ aac: selectedAccount });

  useEffect(() => {
    if (selectedAccount) {
      artistMeta.refetch();
    }
  }, [selectedAccount, artistMeta]);

  const spotifyID = artistMeta?.data?.spotify_obj
    ? JSON.parse(artistMeta?.data?.spotify_obj)?.id
    : null;

  const suggestions = useGetSuggestions({
    spotifyid: spotifyID,
    accountId: selectedAccount,
  });

  // const isrcs = getArtistISRCS({ aac: selectedAccount });

  return (
    <>
      {/* <Modal
        openPortal={spotifyModalIsOpen}
        closePortal={setSpotifyModalIsOpen}
      >
        <SocialSpotify modal closeModal={setSpotifyModalIsOpen} />
      </Modal> */}

      <div>
        {artistMeta.isSuccess
          && !artistMeta?.data?.spotify_obj
          && showSpotifyForm && (
          <>
            <SocialSpotify closeForm={() => setShowSpotifyForm(false)} />
            <Spacer thin />
          </>
        )}
        {suggestions.isLoading && <LoadingSmall />}
        {suggestions?.data && (
          <SuggestionsTable
            data={suggestions?.data}
            highlightColour={highlightColour}
          />
        )}
      </div>
    </>
  );
}

export default SongSuggestions;
